import banner from "../../../courses/module-1/img2.png";

const modulo2 = {
  courseId: "finanzas-personales",
  id: "modulo-2",
  title: "📘 MÓDULO 2: Presupuesto Inteligente",
  estimatedDuration: "2 horas",
  format: "Lectura + actividad práctica + entrega de presupuesto personal",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objetivos",
      title: "🎯 Objetivos del módulo",
      content: [
        "Aprender qué es un presupuesto y por qué es clave para manejar tu dinero de forma consciente.",
        "Diferenciar entre tipos de gastos y detectar a dónde se va tu lana.",
        "Diseñar tu propio presupuesto mensual usando herramientas sencillas y una tabla modelo.",
      ],
    },
    {
      id: "lectura",
      navLabel: "Lectura principal",
      title: "📖 Lectura principal: ¿Cómo se hace un presupuesto?",
      content: [
        {
          type: "paragraph",
          text: "Un presupuesto es una herramienta que te ayuda a planear tus ingresos y tus gastos. Es como un mapa que te dice cuánto puedes gastar y en qué, para no quedarte sin dinero antes de la quincena.",
        },
        {
          type: "paragraph",
          text: "En pocas palabras: Presupuestar es decidir antes de gastar.",
        },
      ],
    },
    {
      id: "importancia",
      navLabel: "¿Por qué es importante?",
      title: "🧠 ¿Por qué es importante?",
      content: [
        {
          type: "list",
          items: [
            "Te evita sorpresas desagradables (“¡¿ya me quedé sin dinero?!”).",
            "Te ayuda a alcanzar metas (como viajar, ahorrar o comprarte algo importante).",
            "Te da control y claridad sobre tu vida financiera.",
          ],
        },
      ],
    },
    {
      id: "tipos-gastos",
      navLabel: "Tipos de gastos",
      title: "💸 Tipos de gastos: fija bien el lente",
      content: [
        {
          type: "table",
          headers: ["Tipo de gasto", "¿Qué es?", "Ejemplos"],
          rows: [
            [
              "Fijos",
              "Siempre están, mes con mes.",
              "Renta, plan de celular, transporte a la uni",
            ],
            [
              "Variables",
              "Cambian según el mes.",
              "Comida fuera, salidas, recargas, gasolina",
            ],
            [
              "Discrecionales",
              "Son gustos o caprichos.",
              "Starbucks, ropa nueva, delivery, gadgets",
            ],
          ],
        },
        {
          type: "paragraph",
          text: "Pro tip: No se trata de eliminar lo que te gusta, sino de decidir con intención cuánto puedes gastar en eso sin descuidar lo demás.",
        },
      ],
    },
    {
      id: "ejemplo-practico",
      navLabel: "Ejemplo práctico",
      title: "📊 Ejemplo práctico: tu tabla de presupuesto en acción",
      content: [
        {
          type: "link",
          href: "https://docs.google.com/spreadsheets/d/1FBMOSfjV1ePG5mUFOwbdvzxE3S_1nfqXG4F_ouuKtVQ/edit?usp=sharing",
          text: "Hoja de cálculo de ejemplo (hacer copia en tu Google Drive)",
        },
        {
          type: "list",
          items: [
            "Sección para anotar tus ingresos mensuales",
            "Lista de gastos organizados por tipo: Fijos, Variables, Ahorro anterior",
            "Línea para registrar tu ahorro mensual",
            "Fórmulas automáticas que calculan totales de ingresos, gastos y ahorro",
            "Balance final: lo que realmente te queda libre",
          ],
        },
      ],
    },
    {
      id: "replicar-tabla",
      navLabel: "Cómo replicarla",
      title: "🛠 ¿Cómo replicar esta tabla?",
      content: [
        {
          type: "orderedList",
          items: [
            "Crea dos columnas: A (Categoría) y B (Monto mensual).",
            "Clasifica tus gastos según las categorías vistas en este módulo.",
            "Usa fórmulas básicas: SUM(B2:B5) para ingresos, SUM(B6:B15) para gastos, etc.",
            "Registra manualmente tu ahorro mensual o suma filas específicas.",
            "Da formato visual (colores, negritas, bordes) para facilitar la lectura.",
          ],
        },
      ],
    },
    {
      id: "ejemplo-real",
      navLabel: "Ejemplo real",
      title: "💬 Ejemplo real y joven: presupuestando como estudiante",
      content: [
        {
          type: "paragraph",
          text: "Andrea tiene 20 años y estudia Psicología en la UNAM. Su ingreso mensual: $1,600 de beca + $800 de trabajo medio turno. Total: $2,400 pesos. Sus gastos: Renta compartida $1,000, Transporte $300, Comida $500, Discrecionales $400. Ahorro planeado: $100. Balance disponible real: $300 pesos.",
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Actividad práctica",
      title: "🧠 Actividad práctica (para entregar)",
      content: [
        "Crea tu propio presupuesto mensual usando la hoja de ejemplo compartida.",
        "Entrega sugerida: link al documento (Drive), PDF, imagen o foto nítida de tu cuaderno, incluyendo: ingresos, gastos, ahorro y meta personal.",
      ],
    },
    {
      id: "lecturas-recomendadas",
      navLabel: "Lecturas recomendadas",
      title: "📚 Lecturas recomendadas",
      content: [
        {
          type: "link",
          href: "https://www.condusef.gob.mx/",
          text: "Guía para hacer tu primer presupuesto – CONDUSEF",
        },
        {
          type: "link",
          href: "https://www.pequenocerdocapitalista.com/",
          text: "¿A dónde se va mi dinero? – Blog Pequeño Cerdo Capitalista",
        },
        {
          type: "link",
          href: "https://www.tiktok.com/@educacionfinancieramx",
          text: "TikTok @educacionfinancieramx – Tips visuales para estudiantes",
        },
      ],
    },
    {
      id: "evaluacion",
      navLabel: "Evaluación rápida",
      title: "📝 Evaluación rápida",
      content: [
        {
          type: "list",
          items: [
            "Identificar tus ingresos reales",
            "Detectar gastos ocultos o innecesarios",
            "Clasificar correctamente tus gastos",
            "Usar una herramienta para armar tu tabla",
            "Fijar una meta financiera",
          ],
        },
      ],
    },
    {
      id: "bibliografia",
      navLabel: "Bibliografía",
      title: "📚 Bibliografía para profundizar",
      content: [
        "Sofía Macías – “Pequeño Cerdo Capitalista”",
        "T. Harv Eker – “Los secretos de la mente millonaria”",
        "CONDUSEF – Educación financiera básica para jóvenes",
      ],
    },
    {
      id: "frase",
      navLabel: "Frase del día",
      title: "🧠 Frase del día",
      content: ["“Quien controla su presupuesto controla su libertad.”"],
    },
  ],
};

export default modulo2;
